import React, { Component } from "react";
import TransferInterbancaService from "../../../services/transferencias/TransferInterbancaService";
import Popup from "react-popup";

import $ from "jquery";
import CuentaExternaService from "../../../services/transferencias/CuentaExternaService";
import TransferCuentasTercerosService from "../../../services/transferencias/TransferCuentasTercerosService";
import { trackPromise } from "react-promise-tracker";
import { formatoSeparadorMilesValue, separadorPuntoMiles } from "../../generico/utils/FormatoInput";
import authService from "../../../services/login/auth.service";
import ReimpresionCuentaTerceroService from "../../../services/consultas/ReimpresionCuentaTerceroService";
import ReimpresionXpressService from "../../../services/consultas/ReimpresionXpressService";
import ReimpresionInterbancariaService from "../../../services/consultas/ReimpresionInterbancariaService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faDownload, faClose } from "@fortawesome/free-solid-svg-icons";
export default class PopupTransferenciaInterbancariaDetalle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      jsonData: {}
    };

    this.initData();
  }

  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
    this.state = this.getInitialState();



  }

  getInitialState = () => {

    $("#inputNroCuenta").val("");

    return {
      entidadNew: "",
      nroCuentaNew: "",
      nombreApellidoNew: "",
      tipoDocNew: "",
      documentoNew: "",
      btnGuardarEnabled: false,

    }
    console.log(this.props.items)

  };




  descargar() {

    //Interbancarias SIPAP

    this.descargarTransfSipap(this.props.items);


    // return (<PopupMostrarDetalle addCuentaCallback={this.addCuentaCallback.bind(this)} />);
  }
  descargarTransfXpress = async (row) => {

    var data = JSON.stringify({
      titulo: "Interbancarias 24 / 7",
      nroOperacion: row.operacion,
      cuentaTitular: row.cuentaOrigen + " - " + row.nombreOrigen,
      tipo: row.tipo,
      moneda: row.moneda,
      cuentaCredito: row.cuentaDestino,
      importeDebito: row.importeDebito,
      importeCredito: row.importeCredito,
      titularCuentaDestino: row.nombreDestino,
      entidad: row.entidad,
      motivo: row.motivo,//
      celularDestinatario: row.cedulaDestino,//
      fechaOperacion: row.fechaTrans
    });

    await trackPromise(
      ReimpresionXpressService.descargarComponente(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }
  descargarTransfInterb = async (row) => {

    var data = JSON.stringify({
      titulo: "Transferencia a Cuentas de Terceros",
      nroOperacion: row.operacion,
      cuentaTitular: row.cuentaOrigen + " - " + row.nombreOrigen,
      tipo: row.tipo,
      moneda: row.moneda,
      cuentaCredito: formatoSeparadorMilesValue(row.cuentaDestino),
      importeDebito: formatoSeparadorMilesValue(row.importeDebito),
      importeCredito: row.importeCredito,
      titularCuentaDestino: row.nombreDestino,
      fechaOperacion: row.fechaTrans
    });

    await trackPromise(
      ReimpresionCuentaTerceroService.descargarComprobante(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }
  descargarTransfSipap = async (row) => {
    await trackPromise(
      ReimpresionInterbancariaService.descagarComponente(
        "Interbancarias via SIPAP",
        row.operacion,
        row.cuentaOrigen +
        " - " +
        row.nombreOrigen,
        row.tipo,
        row.moneda,
        row.cuentaOrigen,
        row.cuentaDestino,
        separadorPuntoMiles(row.importeDebito) ,
        separadorPuntoMiles(row.importeCredito),
        row.nombreDestino,
        row.entidad,
        row.fechaTrans,
        row.tipoDocumentoDestino,//
        row.nroDocDestino,//
        row.motivo
      )
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }


  render() {


    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-transf-interb"
          data-backdrop="false"
        >

          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content modal-content-dt">
              <div title="Close" class="pull-right" style={{ "text-align": "right" }} onClick={() => {
                $("#idFormAddCuenta").validate().resetForm();
                this.setState(this.getInitialState());
              }}><i class="fa fa-times pull-right" data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  $("#idFormAddCuenta").validate().resetForm();
                  this.setState(this.getInitialState());
                }}></i>
              </div>
              <div className="modal-header modal-header-dtt" style={{ "padding-top": " 0px" }}>
                <h4 className="modal-title" style={{ color: "#4e4e4e" }}>Transferencia Interbancaria via SIPAP</h4>


              </div>

              <div className="modal-body">
                <div className="row form-detales-trans">
                  <div className="col-12">
                    <div className="modal-header  modal-header-dt" style={{ padding: "0% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt" >Detalles</h5>
                    </div>
                    {this.props.items.tipoTransferencia === 'BASA-REVERSION' && 
                    
                    <div class="d-flex flex-row">
                      <div class="p-1 col-12"><span><h5 class="rever"><span className="rever-text">Transferencia Reversada</span></h5></span></div>
                     

                    </div>}
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Comprobante</div>
                      <div class="p-1" >{this.props.items.comprobante}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Fecha de operación</div>
                      <div class="p-1" >{this.props.items.fechaTrans}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Monto</div>
                      <div class="p-1" >{formatoSeparadorMilesValue(this.props.items.importeCredito)}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Concepto</div>
                      <div class="p-1" >{this.props.items.concepto}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Documento</div>
                      <div class="p-1" >{this.props.items.nroDocOrigen}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Motivo</div>
                      <div class="p-1" >{this.props.items.motivo}</div>

                    </div>
                    <div className="modal-header modal-header-dt" style={{ color: "#4c4c4c", padding: "4% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt">  Destino</h5>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Nombre</div>
                      <div class="p-1">{this.props.items.nombreDestino}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Cuenta</div>
                      <div class="p-1">{this.props.items.cuentaDestino}</div>

                    </div>
                    {this.props.items.tipoMovimiento === 'D' &&

                      <div class="d-flex flex-row">
                        <div class="p-1 col-5">Entidad</div>
                        <div class="p-1">{this.props.items.entidad}</div>

                      </div>}

                    <div className="modal-header modal-header-dt" style={{ color: "#4c4c4c", padding: "4% 0 1% 0" }} >
                      <h5 className="modal-title modal-title-dt"> Origen</h5>
                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Nombre</div>
                      <div class="p-1">{this.props.items.nombreOrigen}</div>

                    </div>
                    <div class="d-flex flex-row">
                      <div class="p-1 col-5">Cuenta</div>
                      <div class="p-1">{this.props.items.cuentaOrigen}</div>

                    </div>
                    {this.props.items.tipoMovimiento === 'C' &&

                      <div class="d-flex flex-row">
                        <div class="p-1 col-5">Entidad</div>
                        <div class="p-1">{this.props.items.entidad}</div>

                      </div>}

                  </div>

                </div>
              </div>
              <div className="modal-footer modal-footer-dt col-12">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-cu-quintary"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      $("#idFormAddCuenta").validate().resetForm();
                      this.setState(this.getInitialState());
                    }}
                  >
                  <FontAwesomeIcon icon={faClose} />  Cerrar
                  </button>
                </div>
                {this.props.items.tipoMovimiento === 'D' 
                      && this.props.items.tipoTransferencia != 'BASA-REVERSION' &&
                <div className="col-6">
                  <button
                    className="btn btn-cu-primary"

                    onClick={() => {
                      this.descargar();
                    }}
                  >

                    <FontAwesomeIcon icon={faDownload} /> Decargar
                  </button>
                </div>}
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="#"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
